import { Organization } from '../../interfaces';
import { useAppSelector } from '../../store/hooks';
import { selectOrganizations } from '../../store/organizations.reducer';
import {
    createEntityEqualsFilterOperator,
    EntityFilterInput,
    EntityFilterInputProps,
} from './EntityFilterInput';

export const OrganizationFilterInput = (props: Omit<EntityFilterInputProps<Organization>, 'options'>) => {
    const organizations: Organization[] = useAppSelector(selectOrganizations) ?? [];

    return <EntityFilterInput {...props} options={organizations} />;
};

export const SERVER_ORGANIZATION_FILTER_OPERATOR = createEntityEqualsFilterOperator(OrganizationFilterInput);
